import { Routes } from '@angular/router';
import { adminGuard } from './guards/admin-guard';
import { pageGuard } from './guards/page-guard';
import { dynamicPageGuard } from './guards/dynamic-page-guard';
import { dynamicPagePathResolver } from './guards/dynamic-page-path-resolver';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/home/home').then((m) => m.Home),
    canActivate: [pageGuard],
  },
  {
    path: 'venue',
    loadComponent: () => import('./pages/venue/venue').then((m) => m.Venue),
    canActivate: [pageGuard],
  },
  {
    path: 'travel',
    // redirectTo: 'coming-soon',
    loadComponent: () => import('./pages/travel/travel').then((m) => m.Travel),
    canActivate: [pageGuard],
  },
  {
    path: 'hotels',
    // redirectTo: 'coming-soon',
    loadComponent: () => import('./pages/hotels/hotels').then((m) => m.Hotels),
    canActivate: [pageGuard],
  },
  {
    path: 'menu',
    loadComponent: () => import('./pages/menu/menu').then((m) => m.Menu),
    canActivate: [pageGuard],
  },
  {
    path: 'photos',
    loadComponent: () => import('./pages/photos/photos').then((m) => m.Photos),
    canActivate: [pageGuard],
  },
  {
    path: 'photo-admin',
    loadComponent: () => import('./pages/photo-admin/photo-admin').then((m) => m.PhotoAdmin),
    canActivate: [adminGuard],
  },
  {
    path: 'site-admin',
    loadComponent: () => import('./pages/site-admin/site-admin').then((m) => m.SiteAdmin),
    canActivate: [adminGuard],
  },
  {
    path: 'page-admin/:path',
    loadComponent: () => import('./pages/page-blocks/page-blocks').then((m) => m.PageBlocks),
    canActivate: [adminGuard],
  },
  {
    path: 'style-admin',
    loadComponent: () => import('./pages/style-admin/style-admin').then((m) => m.StyleAdmin),
    canActivate: [adminGuard],
  },
  {
    path: 'save-the-date',
    loadComponent: () =>
      import('./pages/envelope/envelope').then((m) => m.Envelope),
  },
  {
    path: 'about',
    loadComponent: () => import('./pages/about/about').then((m) => m.About),
    canActivate: [pageGuard],
  },
  {
    path: 'music',
    loadComponent: () => import('./pages/music/music').then((m) => m.Music),
    canActivate: [pageGuard],
  },
  {
    path: 'rsvp',
    loadComponent: () => import('./pages/rsvp/rsvp').then((m) => m.Rsvp),
    canActivate: [pageGuard],
  },
  {
    path: 'music-admin',
    loadComponent: () => import('./pages/music-admin/music-admin').then((m) => m.MusicAdmin),
    canActivate: [adminGuard],
  },
  {
    path: 'guest-admin',
    loadComponent: () => import('./pages/guest-admin/guest-admin').then((m) => m.GuestAdmin),
    canActivate: [adminGuard],
  },
  {
    path: 'menu-admin',
    loadComponent: () => import('./pages/menu-admin/menu-admin').then((m) => m.MenuAdmin),
    canActivate: [adminGuard],
  },
  {
    path: 'hotel-admin',
    loadComponent: () => import('./pages/hotel-admin/hotel-admin').then((m) => m.HotelAdmin),
    canActivate: [adminGuard],
  },
  {
    path: 'order-of-events-admin',
    loadComponent: () =>
      import('./pages/order-of-events-admin/order-of-events-admin').then(
        (m) => m.OrderOfEventsAdmin,
      ),
    canActivate: [adminGuard],
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login').then((m) => m.Login),
    canActivate: [pageGuard],
  },
  {
    path: 'login/:code',
    loadComponent: () => import('./pages/login/login').then((m) => m.Login),
    canActivate: [pageGuard],
  },
  {
    path: 'logout',
    loadComponent: () => import('./pages/login/login').then((m) => m.Login),
    data: { logout: true },
    canActivate: [pageGuard],
  },
  {
    path: 'coming-soon',
    loadComponent: () => import('./pages/coming-soon/coming-soon').then((m) => m.ComingSoon),
  },
  // {
  //   path: '',
  //   loadComponent: () =>
  //     import('./pages/envelope/envelope').then((m) => m.Envelope),
  // },
  {
    path: '**',
    loadComponent: () => import('./pages/dynamic-page/dynamic-page').then((m) => m.DynamicPage),
    canActivate: [dynamicPageGuard],
    resolve: { path: dynamicPagePathResolver },
  },
];
